import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetDriverLocationsFactoryDependencies = {
  repository: ShipmentRepository
}

export function getDriverLocationsFactory({ repository }: GetDriverLocationsFactoryDependencies) {
  return async function getDriverLocationsManually(
    shipmentUUID: string,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await repository.getDriverLocations(shipmentUUID, config)
    } catch (error) {
      throw new Error('Failed to get driver locations', { cause: error as Error })
    }
  }
}

export function getDriverLocations(shipmentUUID: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const get = getDriverLocationsFactory({ repository })

  return get(shipmentUUID, config)
}
